export const API_URL = 'http://priyo.co.uk/api/v1';
export const EMAIL_FORMAT = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
